var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('Header'),_c('div',{staticClass:"main-container",class:{'fullHeight': _vm.$route.path === '/'}},[_c('router-view'),(_vm.$route.path !== '/')?_c('Footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }